import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { treatments } from '../data/treatments';
import { motion } from 'framer-motion';

export const Treatments = () => {
  const handleConsult = () => {
    window.location.href = 'tel:+919045307888';
  };

  return (
    <section
      id="treatments"
      data-testid="treatments-section"
      className="section-padding bg-[#F9F8F6]"
    >
      <div className="section-container">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-left mb-16 max-w-2xl"
        >
          <span className="caption mb-4 block">Our Treatments</span>
          <h2 className="heading-2 text-[#2D4A3E] mb-6" data-testid="treatments-heading">
            Comprehensive Ayurvedic Care
          </h2>
          <p className="body-large text-[#6B6B6B]">
            From ancient Panchakarma therapies to specialized treatments for modern
            lifestyle disorders, we offer a wide range of Ayurvedic solutions.
          </p>
        </motion.div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {treatments.map((treatment, index) => (
            <motion.div
              key={treatment.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`bg-white rounded-2xl overflow-hidden border border-[#E6E2D8] hover:border-[#C67D63]/30 card-hover group ${
                index === 0 ? 'md:col-span-2 lg:col-span-2' : ''
              }`}
              data-testid={`treatment-card-${treatment.id}`}
            >
              <div className={`relative ${index === 0 ? 'h-64' : 'h-48'}`}>
                <img
                  src={treatment.image}
                  alt={treatment.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2D4A3E]/60 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                      <treatment.icon className="w-4 h-4 text-white" />
                    </div>
                    <h3 className="text-white font-semibold text-lg">{treatment.title}</h3>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <p className="text-[#6B6B6B] mb-4 leading-relaxed">
                  {treatment.description}
                </p>

                {/* Benefits */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {treatment.benefits.slice(0, 3).map((benefit, i) => (
                    <span
                      key={i}
                      className="text-xs px-3 py-1 rounded-full bg-[#F5F2EB] text-[#2D4A3E]"
                    >
                      {benefit}
                    </span>
                  ))}
                </div>

                <Button
                  onClick={handleConsult}
                  variant="ghost"
                  className="text-[#C67D63] hover:text-[#a86850] p-0 flex items-center gap-2 font-medium group/btn"
                  data-testid={`consult-btn-${treatment.id}`}
                >
                  Consult Now
                  <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                </Button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Treatments;
